export enum FileSizeUnit {
	BYTES = 'bytes',
	KILOBYTES = 'kilobytes',
	MEGABYTES = 'megabytes',
	GIGABYTES = 'gigabytes',
}
